module.exports = __webpack_public_path__ + "img/cognitive_img07.319f56f8.png";